const GameLinkReducers = (state = "", action) => {
  switch (action.type) {
    case "storeGameLink":
      return action.payload;
    case "clearGameLink":
      return "";
    default:
      return state;
  }
};
export default GameLinkReducers;
